import { render, staticRenderFns } from "./MyDatingPage.vue?vue&type=template&id=2b2d0b04&scoped=true"
import script from "./MyDatingPage.vue?vue&type=script&lang=js"
export * from "./MyDatingPage.vue?vue&type=script&lang=js"
import style0 from "./MyDatingPage.vue?vue&type=style&index=0&id=2b2d0b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d0b04",
  null
  
)

export default component.exports